import type { RootState } from "@src/store/rootState";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationDraft";

export function getVariationDraftInjection(state: RootState) {
  const mod = getVariationDraft(state);
  return mod?.type === "injection" ? mod : undefined;
}
